<template>
  <div id="app">
    <Navbar v-if="!withoutHeader" />
    <router-view class="f-container content" v-if="!withoutHeader" />
    <router-view class="f-license-container content" v-else />
    <Footer v-if="!withoutHeader" />
  </div>
</template>

<script>
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
export default {
  name: "App",
  components: {
    Navbar,
    Footer
  },
  computed: {
    withoutHeader() {
      if (this.$route.path == "/app/license" || this.$route.path == "/logo") {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #090909;
}

.f-license-container {
  padding-left: 0.5em;
  padding-right: 0.5em;
}

.content {
  margin-top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue